<template>
  <div>
    <ul data-v-a1201187="" class="tab-a">
      <li data-v-a1201187="" :class="[index == 1 ? 'active' : '']" @click="onClick(1)">{{ $t('_qb._cbjl') }}</li>
      <li data-v-a1201187="" :class="[index == 2 ? 'active' : '']" @click="onClick(2)">{{ $t('_m._yhzz') }}</li>
      <li data-v-a1201187="" :class="[index == 3 ? 'active' : '']" @click="onClick(3)">{{ $t('_qb._jyjl') }}</li>
      <li data-v-a1201187="" :class="[index == 4 ? 'active' : '']" @click="onClick(4)">{{ $t('_qb._bddz') }}</li>
      <li data-v-a1201187="" :class="[index == 5 ? 'active' : '']" @click="onClick(5)">{{ $t('_qb._txjl') }}</li>
    </ul>
  </div>
  <div>
    <!-- <transaction-records v-if="index == 1"> </transaction-records> -->
    <deposit-records v-if="index == 1"> </deposit-records>
    <bank-deposit-records v-if="index == 2"> </bank-deposit-records>
    <wallet-log-records v-if="index == 3"> </wallet-log-records>
    <address-records v-if="index == 4"> </address-records>
    <withdrawal-records v-if="index == 5"></withdrawal-records>
    <!-- <user-transfer-records v-if="index == 4"> </user-transfer-records> -->
  </div>
</template>

<script>
import BankDepositRecords from '@/components/wallet/BankDepositRecords.vue'
import DepositRecords from '@/components/wallet/DepositRecords.vue'
import WalletLogRecords from '@/components/wallet/WalletLogRecords.vue'
import AddressRecords from '@/components/wallet/AddressRecords.vue'
import WithdrawalRecords from '@/components/wallet/WithdrawalRecords.vue'
export default {
  components: { WalletLogRecords, AddressRecords, DepositRecords, WithdrawalRecords, BankDepositRecords },
  name: 'walletVue',
  data() {
    return {
      index: 1
    }
  },
  created() {
    if (this.$route.query.i) {
      this.index = Number(this.$route.query.i)
    }
  },
  methods: {
    onClick(index) {
      this.index = index
    }
  }
}
</script>

<style>
.hbox {
  padding: 15px 10px;
  display: flex;
}

.hb2b {
  flex: 1;
  text-align: left;
}

.ha {
  font-size: 15px;
}

.hd {
  font-size: 15px;
}

.hw150 {
  flex: 0 0 150px;
}

.hw200 {
  flex: 0 0 200px;
}

.hwauto {
  flex: 1 1 auto;
}

.hd:nth-child(2n) {
  background: #f5f5f5;
}
</style>
